import "./vue-apps/search";